<button type="button" (click)="scrollToTop()" *ngIf=" this.scrollY > 800" class="btn btn-secondary position-fixed d-flex align-content-center justify-content-center fs-5 rounded-circle text-decoration-none btn-scroll-totop">
    <i class="bx bx-chevron-up text-white"></i>
</button>